import React, { useContext, useEffect, useState } from "react";

import {
  Paper,
  makeStyles,
  Button,
  Box,
  Table,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  Typography,
  Backdrop,
  CircularProgress,
  TableContainer,
  useTheme,
} from "@material-ui/core";

import AddIcon from "@material-ui/icons/Add";
import { Pagination } from "@material-ui/lab";
import DeleteIcon from "@material-ui/icons/Delete";
import CreateCategory from "./CreateCategory";
import UpdateCategory from "./UpdateCategory";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import AlertDialog from "../../components/Alert/AlertDialog";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Notification from "../../components/Notification/Notification";
import EditIcon from "@material-ui/icons/Edit";
import {
  deleteCategory,
  getCategory,
} from "../../store/action/category/categoryAction";
import DocType from "./DocType";
import EnhancedTableHead from "./EnhancedTableHead";
import { headCells } from "./Headcells";
import moment from "moment/moment";
import { ThemeContext } from "../../App";

const useStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
    // overflowX: "auto",
    padding: 20,
    background: theme.palette.background.main
  },
  container: {
    marginTop: "15px",
    maxHeight: "calc(100vh - 260px)",
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  viewBtn: {
    display: "flex",
    alignItems: "center",
  },
}));

const Category = () => {
  const theme = useTheme();
  const { mode } = useContext(ThemeContext);
  const history = useHistory();
  const classes = useStyle();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [Id, setId] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [page, setPage] = useState(1);
  const [openUpdate, setOpenUpdate] = useState(false);
  const [openDocType, setOpenDocType] = useState(false);
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("title");

  const { getCategoryItem, loading } = useSelector((state) => state.category);
  const loginUserInfo = JSON.parse(localStorage.getItem("loginUserInfo"));

  const handleClickOpen = (id) => {
    setOpen(true);
  };

  const handlekOpenSubCat = () => {
    history.push("/staff/subCategory");
  };

  const handleClose = (action) => {
    setOpen(false);
    if (action === "update") {
      getCategory(page);
    }
    setOpenUpdate(false);
  };

  const handleDocTypeClose = () => {
    setOpenDocType(false);
  };

  const deleteCategories = (category_id) => {
    setDisabled(true);
    setId(category_id);
    setDeleteOpen(true);
  };
  const deleteCategoryClose = () => {
    setDeleteOpen(false);
  };
  const alertResponse = (id) => {
    if (disabled === true) {
      dispatch(deleteCategory(id));
    }
    setDisabled(false);
  };

  const handleUpdateClickOpen = (id) => {
    setOpenUpdate(true);
    setId(id);
  };

  const handleDocTypeClickOpen = (id) => {
    setOpenDocType(true);
    setId(id);
  };

  const handleRequestSort = (
    property,
    setOrder,
    setOrderBy,
    orderBy,
    order
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  useEffect(() => {
    dispatch(getCategory(orderBy, order));
  }, [dispatch, orderBy, order]);

  useEffect(() => {
    document.documentElement.style.setProperty('--bg-color', theme.palette.grey[1000]);
    document.documentElement.style.setProperty('--sticky-header', theme.palette.thead);
    document.documentElement.style.setProperty('--sticky-odd', theme.palette.background.stickyOdd);
    document.documentElement.style.setProperty('--sticky-even', theme.palette.background.stickyEven);
  }, [mode]);

  return (
    <>
      <Paper className={`${classes.root} mb-6`}>
        <Box
          className="mb-5"
          display="flex"
          alignItems="center"
          justifyContent="flex-end"
        >
          <div className="ml-5">
            {((loginUserInfo?.role === "STAFF" &&
              loginUserInfo?.permissions?.some(p => p.toLowerCase() === "compliance-category-create")) || (loginUserInfo?.role !== "STAFF")) && (<Button
                variant="contained"
                style={{ textTransform: "capitalize" }}
                color="primary"
                onClick={handleClickOpen}
              >
                <AddIcon className="mr-2" />
                Add Compliance Category
              </Button>)}
          </div>

          <div className="ml-5">
            <Button
              variant="contained"
              style={{ textTransform: "capitalize" }}
              color="secondary"
              onClick={handlekOpenSubCat}
            >
              View Sub Category
            </Button>
          </div>
        </Box>

        <TableContainer className={classes.container}>
          <Table stickyHeader aria-label="sticky table">
            <EnhancedTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={(event, property) => {
                handleRequestSort(
                  property,
                  setOrder,
                  setOrderBy,
                  orderBy,
                  order
                );
              }}
              rowCount={getCategoryItem?.data?.data?.length}
              headCells={headCells[0]}
            />

            <TableBody>
              {getCategoryItem?.data &&
                getCategoryItem.data.map((row, index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell scope="row" style={{ color: theme.palette.listItem }}>{index + 1}</TableCell>
                      <TableCell align="left" style={{ color: theme.palette.listItem }}>{row.title}</TableCell>
                      <TableCell align="left" style={{ color: theme.palette.listItem }}>{row.is_active}</TableCell>
                      <TableCell align="left" style={{ color: theme.palette.listItem }}>{row.user_name ?? "-"}</TableCell>
                      <TableCell align="left" style={{ color: theme.palette.listItem }}>{moment(row.created_at).format("DD-MMM-YYYY")}</TableCell>
                      <TableCell align="right">
                        <Box
                          display="flex"
                          alignItems="center"
                        // justifyContent="flex-end"
                        >
                          {((loginUserInfo?.role === "STAFF" &&
                            loginUserInfo?.permissions?.some(p => p.toLowerCase() === "compliance-category-create")) || (loginUserInfo?.role !== "STAFF")) && (<Button
                              color="secondary"
                              onClick={() => handleDocTypeClickOpen(row.id)}
                            >
                              <AddCircleOutlineIcon className="mr-3" />
                              <Typography>Add Types </Typography>
                            </Button>)}

                          {((loginUserInfo?.role === "STAFF" &&
                            loginUserInfo?.permissions?.some(p => p.toLowerCase() === "compliance-category-update")) || (loginUserInfo?.role !== "STAFF")) && (<IconButton
                              onClick={() => handleUpdateClickOpen(row.id)}
                              style={{ padding: 6 }}
                            >
                              <EditIcon color="primary" />
                            </IconButton>)}
                          {((loginUserInfo?.role === "STAFF" &&
                            loginUserInfo?.permissions?.some(p => p.toLowerCase() === "compliance-category-delete")) || (loginUserInfo?.role !== "STAFF")) && (<IconButton
                              onClick={() => deleteCategories(row.id)}
                              style={{ padding: 6 }}
                            >
                              <DeleteIcon color="secondary" />
                            </IconButton>)}
                        </Box>
                      </TableCell>
                    </TableRow>
                  );
                })}
              {!getCategoryItem?.data && (
                <TableRow>
                  <TableCell scope="row" colSpan="15">
                    <div className="" align="center">
                      Sorry, Category not available!
                    </div>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      <CreateCategory open={open} handleClose={handleClose} />
      <UpdateCategory
        openUpdate={openUpdate}
        handleClose={handleClose}
        id={Id}
      />
      <DocType
        openDocType={openDocType}
        handleDocTypeClose={handleDocTypeClose}
        id={Id}
      />
      <AlertDialog
        id={Id}
        response={alertResponse}
        open={deleteOpen}
        close={deleteCategoryClose}
        title="Delete Category"
        description="Are you sure you want to delete Category?"
        buttonName="Delete"
      />

      {loading ? (
        <Backdrop className={classes.backdrop} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : (
        ""
      )}
    </>
  );
};

export default Category;
